import React from 'react';
import { RACE_STATIONS } from '../data';

export const RaceSection = () => (
  <section id="race" className="container-ninja section-spacing" data-testid="hyrox-race-section">
    <div className="max-w-4xl mx-auto">
      <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3">Understanding the Format</p>
      <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">8 Runs. 8 Stations. 1 Race.</h2>
      <p className="text-zinc-400 mb-8 max-w-2xl">
        HYROX is a standardized indoor fitness race: 1km run followed by a functional exercise station, repeated eight times.
        The same format everywhere in the world. Your time. Your benchmark. Your progress.
      </p>

      <div className="grid gap-2">
        {RACE_STATIONS.map((s, i) => (
          <div key={s.name} className="flex items-stretch group" data-testid={`station-${i + 1}`}>
            <div className="w-20 flex-shrink-0 bg-[#e8ff00]/5 border border-[#e8ff00]/20 flex flex-col items-center justify-center py-3">
              <span className="text-[10px] text-zinc-500 uppercase tracking-wider">Run</span>
              <span className="text-[#e8ff00] font-heading text-lg">{i + 1}km</span>
            </div>
            <div className="flex-1 bg-zinc-900/80 border border-zinc-800 group-hover:border-[#e8ff00]/30 transition-colors px-5 py-3 flex items-center justify-between">
              <div>
                <div className="flex items-center gap-3">
                  <span className="w-7 h-7 flex items-center justify-center bg-[#E63946]/10 text-[#E63946] text-xs font-heading font-bold border border-[#E63946]/20">S{i + 1}</span>
                  <span className="text-white font-heading text-sm">{s.name}</span>
                  <span className="text-zinc-600 text-xs">{s.distance}</span>
                </div>
              </div>
              <p className="text-zinc-500 text-xs hidden md:block max-w-xs text-right">{s.tip}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-zinc-900/80 border border-zinc-800 p-5 flex items-center justify-between">
        <div>
          <p className="text-zinc-500 text-[10px] uppercase tracking-wider">Average Finish Time</p>
          <p className="text-white font-heading text-2xl">~1:30:00</p>
        </div>
        <div className="text-right">
          <p className="text-zinc-500 text-[10px] uppercase tracking-wider">Divisions</p>
          <p className="text-zinc-300 text-sm">Open, Pro, Doubles, Relay</p>
        </div>
      </div>
    </div>
  </section>
);
